import React from 'react';
import { Container, Paper, Typography, CircularProgress } from '@mui/material';
import useViewLoader from '../hooks/useViewLoader.js';
import { getFramePlayer, getViewPlayer, getWidgetPlayer } from '../../../../api/index.js';
import useViewToken from '../hooks/useViewToken.js';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

const PlayerProfileView = ({ id }) => {

  const { joueur } = useParams();

  const [htmlContent, setHtmlContent] = useState('');

  const { token, expiresIn, fetchToken } = useViewToken()

  const { loading, data, error, loadData } = useViewLoader(getFramePlayer, joueur && joueur.split("_")[1]);

  useEffect(() => {
    // Appelez la fonction init() du bundle avec les données
    if (data) {
      setHtmlContent(data);
      // Exécuter les scripts après l'insertion du HTML
      setTimeout(() => {
        const scripts = document.querySelectorAll('#widget-container script');
        scripts.forEach((script) => {
          const newScript = document.createElement('script');
          if (script.src) {
            newScript.src = script.src; // Si le script a un src, on le copie
          } else {
            newScript.textContent = script.textContent; // Sinon, on exécute son contenu
          }
          document.body.appendChild(newScript); // Ajouter et exécuter le script
        });
      }, 0);
    }
  }, [data])
  
  return (
    <Container>
      <Paper elevation={3} style={{ padding: '16px' }}>
        {loading ? (
          <CircularProgress />
        ) : (
          <div
            id="widget-container"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        )}
      </Paper>
    </Container>
  );
};

export default PlayerProfileView;